module.exports = __webpack_public_path__ + "img/rocket-rafiki.6cae375b.svg";